<form [formGroup]="form" (ngSubmit)="save()">
  <h1 mat-dialog-title>Envio de informes</h1>
  <div mat-dialog-content>
    <mat-spinner diameter="30" *ngIf="loading"></mat-spinner>
    <mat-form-field *ngIf="!loading" class="full-width">
      <mat-select
        formControlName="sector"
        placeholder="Sector destino"
        required
      >
        <mat-option *ngFor="let sector of sectors" [value]="sector">
          {{ sector.Name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="f.sector.errors && f.sector.errors.required">
        Seleccione un sector
      </mat-error>
    </mat-form-field>
  </div>
  <div class="clearfix">
    <div class="pull-right">
      <button mat-button type="submit" [disabled]="sending">Aceptar</button>
      <button
        mat-button
        type="button"
        cdkFocusInitial
        (click)="onNoClick()"
        [disabled]="sending"
      >
        Cancelar
      </button>
    </div>
  </div>
</form>
